export * from './useTenantedApplicationConfig';
